import { render, staticRenderFns } from "./BaseChecklist.vue?vue&type=template&id=c5f86a2e&"
import script from "./BaseChecklist.vue?vue&type=script&lang=js&"
export * from "./BaseChecklist.vue?vue&type=script&lang=js&"
import style0 from "./BaseChecklist.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports